// @flow
import client from '../../client'
import { config } from '../../config'
import format from '../../utils/format'

import type { Options, PaymentIntentData } from './createPaymentIntent'

export const UPDATE_INTENT_ENDPOINT = '/stripe_payments/{0}/'

export const updatePaymentIntent = (
  paymentIntentId: string,
  body: $Shape<Options>
): Promise<PaymentIntentData> =>
  client.put(format(UPDATE_INTENT_ENDPOINT, paymentIntentId), {
    body,
    baseUrl: config.BASE_URL_PAYMENTS,
  })

export default updatePaymentIntent
